import m from "mithril";
import { MithrilTsxComponent } from "mithril-tsx-component";
import { cleanString } from "oj-utils";
const cache = {};
const placeholder = `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler" width="40" height="40" viewBox="0 0 24 24" stroke-width="1.5" stroke="#000000" fill="none" stroke-linecap="round" stroke-linejoin="round"></svg>`;
export class Svg extends MithrilTsxComponent {
    oninit(v) {
        this.load(v.attrs.src);
    }
    view(v) {
        const svg = cache[v.attrs.src];
        return m("i", { className: cleanString("Svg", v.attrs.className) }, m.trust(svg || placeholder));
    }
    onbeforeupdate(v, o) {
        if (v.attrs.src !== o.attrs.src)
            this.load(v.attrs.src);
    }
    async load(src) {
        try {
            cache[src] ??= await fetch(src).then(x => x.text());
        }
        catch (err) {
            console.error(`Failed to load SVG: ${src}`, err);
        }
        m.redraw();
    }
}
